import { useEffect } from 'react';

export const useVideoControls = (videoControls, videoRef) => {
    const updateVideoFromSSE = (videoControls, videoRef) => {
        switch(videoControls.play) {
            case true:
                videoRef.current.play();
                break;
            case false:
                videoRef.current.pause();
                break;
            default:
                console.log(`Found no match for the video control event: ${videoControls}`);
        }
    };
    
    useEffect(() => {
        if (videoControls) {
            updateVideoFromSSE(videoControls, videoRef);
        }
    }, [videoControls]);
};
